module.exports = __webpack_public_path__ + "static/img/cont45 (3).3205a48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45 (3).jpg
// module id = 0Oly
// module chunks = 0